import { Icon, Space, Text } from '@billy/design-system'
import { ReactElement, ReactNode, useMemo } from 'react'
import { Trans } from 'react-i18next'

import { InvoiceType } from '@features/invoicesLegacy/types/invoiceType'

import { BillType } from '../../../bills/enums/billType'
import { PayableSubjectType } from '../../../paymentReconciliationModal/types/payableSubjectType'
import * as Styled from './styles'

interface SubjectReconciliationSuggestionProps {
  subjectType?: PayableSubjectType | null
  children?: ReactNode
  withIcon?: boolean
}

export const SubjectReconciliationSuggestion = ({
  subjectType,
  children,
  withIcon = false,
}: SubjectReconciliationSuggestionProps): ReactElement => {
  const label = useMemo(() => {
    switch (subjectType) {
      case BillType.Bill:
        return (
          <Trans i18nKey="bill.payment_reconcile.found_match">
            We found a <strong>bank line</strong> that looks like a match for this bill!
          </Trans>
        )
      case InvoiceType.Invoice:
        return (
          <Trans i18nKey="invoices.payment_reconcile.found_match">
            We found a <strong>bank line</strong> that looks like a match for this invoice!
          </Trans>
        )
    }
  }, [subjectType])

  return (
    <Styled.ReconciliationSuggestionWrapper>
      <Styled.ReconciliationSuggestionHeader>
        {withIcon && (
          <>
            <Icon icon="sparkles" size="lg" color="currentColor" />
            <Space size="s4" horizontal />
          </>
        )}
        <Text>{label}</Text>
      </Styled.ReconciliationSuggestionHeader>
      <Space size="s12" />
      {children}
    </Styled.ReconciliationSuggestionWrapper>
  )
}
